<template>
  <div class="mainWorkList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="请输入工作标题" v-model="workTitle"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="workType" placeholder="请选择工作类型">
            <el-option label="请选择工作类型" value=""></el-option>
            <el-option v-for="item in workTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="search">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jumpToAdd">新增重点工作</el-button>
      <el-table :data="workList" class="wid100" :row-class-name="tableRowClassName"
        :height="workList.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="title" label="工作标题">
        </el-table-column>
        <el-table-column prop="workType" label="工作类型">
        </el-table-column>
        <!-- <el-table-column prop="info" label="工作内容">
        </el-table-column> -->
        <el-table-column prop="createTime" label="创建时间">
					<template slot-scope="scope">{{scope.row.createTime | time}}</template>
				</el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteItem(scope.row)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
      <el-dialog :title="state? '新增重点工作':'修改重点工作'" :visible.sync="review" :close-on-click-modal="false" center
        top="130px" width="1200px" @closed="handleDialogClosed">

        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" @submit.native.prevent
          class="form">
          <el-form-item label="工作标题" prop="title">
            <el-input maxlength='50' class="select" v-model="ruleForm.title" placeholder="请输入工作标题">
            </el-input>
          </el-form-item>
          <el-form-item label="工作类型" prop="workType">
            <el-select v-model="ruleForm.workType" class="select" placeholder="请选择工作类型">
              <el-option v-for="item in workTypeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="工作内容" prop="info">
            <el-input class="select" v-model="ruleForm.info" type="textarea" :rows="5" placeholder="请输入工作内容"></el-input>
          </el-form-item> -->
          <el-form-item label="工作内容" prop="info" class="editor-width">
            <quill-editor v-model="ruleForm.info" ref="myQuillEditor" @change="onEditorChange($event)"></quill-editor>
            <span class="editorText" v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
            <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
        </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
          <el-button :disabled="isDisabled" type="primary" @click="onSubmit('ruleForm')">{{$t('lang.btn_save')}}
          </el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
  /**
   *@ClassName:mainWorkList
   *@Description:重点工作
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2024-07-01
   */
  export default {
    name: '/manage/main.videoMonitorInterface',
    data() {
      return {
        workTitle: '', // 工作标题
        workType: '', // 工作类型
        workTypeList: [{
          id: '月度',
          name: '月度',
        }, {
          id: '季度',
          name: '季度',
        }, {
          id: '年度',
          name: '年度',
        }], // 工作类型列表
        workList: [], // 工作列表
        saveData: '', // 存储验证保存按钮字符串
        isDisabled: true, // 置灰标识
        state: true, // 判断是添加还是修改状态
        id: '', // 保存id
        flag: '', // 根据1或者0判断是保存还是修改
        rules: {
          title: [{
            required: true,
            message: '请输入工作标题',
            trigger: 'blur'
          }],
          workType: [{
            required: true,
            message: '请选择工作类型',
            trigger: 'change'
          }],
          info: [{
            required: true,
            message: '请输入工作内容',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          title: '', // 标题
          workType: '', // 工作类型
          info: '', // 工作内容 
        },
        review: false, // 打开关闭dialog
        pageCount: 0, // 总页数
        pageNum: 1, // 页数
        pageSize: 10, // 每页显示数量
        isLength: 0, // 富文本字数长度
      }
    },
    created() {
      this.getData()
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      // 添加页面弹出
      jumpToAdd() {
        this.state = true
        this.review = true
        this.flag = 1
      },
      // 修改页面弹出
      edit(row) {
        this.flag = 0
        this.ruleForm.title = row.title
        this.ruleForm.workType = row.workType
        this.ruleForm.info = row.info
        // flag为1是添加 flag为0是修改
        this.state = false
        this.row = row
        this.id = row.id
        this.review = true
        this.saveData = JSON.stringify(this.ruleForm)
        // 这是用来计算当前字符数，当有内容时，减去默认前后缀占位数
        var count = 0
        if (this.ruleForm.info != '') {
          count = 7
        }
        this.isLength = this.ruleForm.info.length - count
      },
      // 模糊搜索
      search() {
        this.pageNum = 1
        this.getData()
      },
      // 获取重要工作列表
      getData() {
        let loading = this.$loading()
        this.$get(
          `/keyWork?gardenId=` + this.$store.getters.gardenId +
          `&title=${this.workTitle}&workType=${this.workType}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.workList = res.list.reverse()
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 新增、保存
      onSubmit(formName) {
        let params = {
          gardenId: this.$store.getters.gardenId,
          title: this.ruleForm.title,
          workType: this.ruleForm.workType,
          info: this.ruleForm.info,
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            // 添加
            if (this.flag == 1) {
              this.$post('/keyWork', params).then(res => {
                  loading.close()
                  if (res.errCode == 0) {
                    this.$message({
                      type: 'success',
                      message: '添加成功'
                    })
                    this.review = false
                    this.getData()
                  } else {
                    this.$message({
                      type: 'success',
                      message: res.errMsg
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else if (this.flag == 0) {
              // 修改
              this.$patch(`/keyWork/${this.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message({
                      type: 'success',
                      message: '修改成功'
                    })
                    this.review = false
                    this.getData()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          }
        })
      },
      // 删除
      deleteItem(row) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            this.$delete(`/keyWork/${row.id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.pageNum = 1
                  this.getData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.ruleForm.info === '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
      },
      // 清空表单
      resetForm(formName) {
        this.ruleForm.id = ''
        this.ruleForm.title = ''
        this.ruleForm.workType = ''
        this.ruleForm.info = ''
      },
      // 序号,
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.getData()
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.ruleForm.title = ''
        this.ruleForm.workType = ''
        this.ruleForm.info = ''
      },
    },
  }
</script>
<style lang="scss">
</style>